import { FC, useEffect, useRef, useState } from 'react'

import { ReactComponent as ArrowIcon } from 'src/assets/svg/diagonalArrowUp.svg'
import { ReactComponent as MehIcon } from 'src/assets/svg/lucide_meh.svg'
import { Tooltip } from 'src/components/Tooltip'
import { KeywordFetchKeywordsWithStats } from 'src/services/__generated__/api'

import styles from './topNeutralKeywordCard.module.scss'

interface TopNeutralKeywordCardProps {
  hasData?: boolean
  keyword?: KeywordFetchKeywordsWithStats
  percentage?: number
}

export const TopNeutralKeywordCard: FC<TopNeutralKeywordCardProps> = ({
  hasData = false,
  keyword,
  percentage = 0,
}) => {
  const keywordRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const el = keywordRef.current
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight)
    }
  }, [keyword])

  const name = keyword?.name
  const mentions = keyword?.neutralCount || 0

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <MehIcon className={styles.icon} />
        <h3 className={styles.title}>Top Neutral Keyword</h3>
      </div>
      <div className={styles.body}>
        {hasData && name ? (
          <>
            <div className={styles.keywordRow}>
              {isTruncated ? (
                <Tooltip
                  overlay={name}
                  overlayClassName="topCampaignTooltip"
                  placement="top"
                >
                  <span className={styles.keyword} ref={keywordRef}>
                    {name}
                  </span>
                </Tooltip>
              ) : (
                <span className={styles.keyword} ref={keywordRef}>
                  {name}
                </span>
              )}
              {!!percentage && (
                <span className={styles.badge}>
                  <ArrowIcon className={styles.arrowIcon} />
                  {percentage}%
                </span>
              )}
            </div>
            <div className={styles.mentionsRow}>
              <span className={styles.dot} />
              <span className={styles.mentions}>
                {mentions.toLocaleString()} Neutral{' '}
                {mentions === 1 ? 'Mention' : 'Mentions'}
              </span>
            </div>
          </>
        ) : (
          <div className={styles.noData}>No Data</div>
        )}
      </div>
    </div>
  )
}
